const strings = {
  nielle: "NIELLE",
  ninielle: {
    title: "NINIELLE",
    body: `Hi, there! I'm Ninielle, or just Nielle.

    I’m a Software Engineer with a specialty in Web Development and Data Engineering. I am incredibly passionate about Frontend and Interaction design, with personal passions in the arts and design in general. Having gone from FinTech, to S.A.A.S, and now the Pharmaceutical industry, I have found my vocation in creating solutions that uplift those in need.

    It is my personal goal to create solutions such as app interfaces and medical devices - this maximizes my expertise in software engineering while making use of my training under good healthcare, product, and manufacturing practices which I have received during my time in Pfizer. It also allows me to utilize my creative brain through design and development, and overall appeals to my personal passions and professional vocation.
    `,
    subtitle: `Click Circles below to learn more!`,
  },
  career: {
    title: "CAREER GOAL",
    body: `My journey through various jobs and software development industries has taught me of my need for work that is both creative and fulfilling on a vocational level. Though I started my career in highly lucrative Fintech and Startup Technology positions, I decided to step out of these industries to figure out what fulfills me in the long term. I have been witness to the large promises of tech industries and their failure to reach those in greatest need due to lack of resources or infrastructure. This led me to dream of creating solutions that are truly accessible and feasible to implement.

    Luckily, I landed a position in Pfizer, where I now work on data I find valuable in its real-world impact on patients globally. My exposure to clinical supply operations opened up my interest in one day being more directly involved in the R&D of the medical items we deliver. And so, I have concretized a goal:
    `,
    subtitle:
      "To uplift the lives of those with\nChronic Pain/Illnesses through\naccessible medical products",
  },
  studies: {
    title: "FURTHER STUDIES",
    body: `It is my intention to apply for Masters in the realms of Software Engineering, Human Computer Interaction, and Health Informatics in order to fulfil this dream of mine. Though I already have lengthy experience in Software Engineering, I believe that an academic environment would provide the resources needed to delve further into realms I would like to research and specialize in:
    
    MS HEALTHCARE DATA SCIENCE:
    > Data Visualization, Analytics, and AI/ML specific to the design and development of medical applications and devices.
    
    MS Human Centered Design/Interaction
    > Interaction Design and Application development with focus on accessibility and sensory design, human impact, and usage by those with Chronic Pain or Illnesses.
    `,
    subtitle: "Research Intentions",
  },
  resume: {
    title: "THE JOURNEY",
    body: `2016 - 2021: B.S. Management Information Systems
    @ Ateneo de Manila University
    > Studies focusing on Project Management and Data Systems
    > Specialization in Interactive Multimedia

    2021 - 2024: Software Engineer
    @ Maya Philippines, Inc
    > Intensive training on Data Science, Full Stack, and DevOps
    > Spearhead the development of a Biller Management Dashboard
    > Mobile development for Maya Consumer App (Maya Wallet)

    2024 - Present: Data Analytics & Full Stack Development
    @ Pfizer
    > Development and maintenance of various Analytics Dashboards (web apps, Power BI, Spotfire BI, etc.)
    > Development of software solutions to support Global Clinical Supply Operations
    `,
    subtitle: "Next: Further Studies",
  },
  software: {
    title: "SOFTWARE\nDEVELOPER",
    body: `My skillset in Software Engineering is very well-rounded and versatile. Thanks to my college degree and specialization, I have experience with Information Systems Design and Interactive and Computational Multimedia. Thanks to my professional work, I have come to specialize in Full Stack Web Development and Data Engineering for Visual Analytics.

    2 Positions held under highly sought out industries
    3 Fully functional web app projects under my lead as a developer
    4 Business Analytics Visualization Dashboards created with the use of PowerBI or Spotfire BI
    `,
    subtitle: `FULL-STACK ENGINEER /
    DATA ENGINEER`,
  },
  multimedia: {
    title: "JOURNEY THROUGH INDUSTRIES",
    body: `My journey through various jobs and software development industries has taught me of my need for work that is both creative and fulfilling on a vocational level. I have been witness to the large promises of tech industries and their failure to reach those in greatest need due to lack of resources or infrastructure. This led me to dream of creating solutions that are truly accessible and feasible to implement. 
    
    Entering the Pharmaceutical industry only allowed me to specify my goal: uplift the lives of those with chronic pain and/or illnesses through accessible medical products. My exposure to clinical supply operations opened up my interest in one day being more directly involved in the R&D of the medical items we deliver. Though there is no singular experience that brought me to this, I feel greatly fulfilled in my role knowing it brings life-saving medicine to those in need, and am inspired to work in similar fields. 
    `,
    subtitle: "NEXT: FURTHER STUDIES",
  },
  subtitle: "SOFTWARE & DATA ENGINEER",
  fname: "Niña Gabrielle A. Pascual",
  lipsum1: "Lorem ipsum dolor sit amet.",
  lipsum2:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam luctus vel sapien sit amet tincidunt. In dignissim vitae ipsum eget ullamcorper. Ut aliquam consequat erat a eleifend. Nulla ornare ipsum a est ultricies, quis aliquet lectus imperdiet. Pellentesque egestas, tortor a faucibus malesuada, felis enim tristique augue, ac posuere risus sem nec velit. Morbi ut interdum lectus. Mauris a ultricies nulla, sit amet dapibus lacus. Mauris hendrerit mattis tellus, a facilisis magna porta eu. In molestie porta sem, nec sodales dui. Aenean interdum magna et lorem porta, ut vulputate felis accumsan. Nullam ullamcorper libero non enim vehicula, eget dictum mauris pulvinar.",
};

export default strings;
